<template>
  <select v-model="selectedOption" @change="switchCurrency">
    <option value="xdr">UA</option>
    <option value="usd">USD</option>
  </select>
</template>

<script setup>
import { ref } from 'vue'
import { useCurrencyStore } from '@/stores/currency'

const currencyStore = useCurrencyStore()
const selectedOption = ref(currencyStore.currency)

const switchCurrency = () => {
  localStorage.setItem('user-currency', selectedOption.value)
  currencyStore.currency = selectedOption.value
}
</script>

<style lang="scss" scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: #ffffff;
  border: none;
  border-right: 1px solid #e4e7ed;
  color: #0c7cac;
  cursor: pointer;
  display: inline;
  font-size: 0.6rem;
  height: 1rem;
  margin: 0;
  padding: 0 0.5rem;

  &:hover, &:focus {
    text-decoration: underline;
  }

  svg {
    pointer-events: none;
  }
}
</style>
